import React, { useState } from 'react';

import moment from 'moment';
import * as Yup from 'yup';

import { Report } from '~/components';
import { Autocomplete, RadioGroup, Select } from '~/components/Form';
import { t } from '~/helpers';

function Rellmc() {
  const [open, setOpen] = useState(true);
  const [valuePosto, setValuePosto] = React.useState([]);

  const end = moment().set({ hour: 23, minute: 59, second: 59 });

  // combobox de anos
  const anoInicial = 2018;
  const anoAtual = new Date().getFullYear();

  const anos = [];

  for (let ano = anoInicial; ano <= anoAtual; ano++) {
    anos.push({ label: ano.toString(), value: ano });
  }

  // combobox de meses
  const meses = [
    { value: '1', label: t('s.geral.opcoes.janeiro') },
    { value: '2', label: t('s.geral.opcoes.fevereiro') },
    { value: '3', label: t('s.geral.opcoes.marco') },
    { value: '4', label: t('s.geral.opcoes.abril') },
    { value: '5', label: t('s.geral.opcoes.maio') },
    { value: '6', label: t('s.geral.opcoes.junho') },
    { value: '7', label: t('s.geral.opcoes.julho') },
    { value: '8', label: t('s.geral.opcoes.agosto') },
    { value: '9', label: t('s.geral.opcoes.setembro') },
    { value: '10', label: t('s.geral.opcoes.outubro') },
    { value: '11', label: t('s.geral.opcoes.novembro') },
    { value: '12', label: t('s.geral.opcoes.dezembro') },
  ];

  function handleSerializeForm(params) {
    const idPosto = valuePosto.idposto === null ? '' : valuePosto.idposto;
    return {
      ...params,
      idposto: idPosto,
    };
  }

  async function handleValidate(param) {
    try {
      const schema = Yup.object().shape({
        unidadecomboio: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .nullable(),
      });

      await schema.validate(param, {
        abortEarly: false,
      });
    } catch (err) {
      const form = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          form[error.path] = error.message.replace(`${error.path} `, '');
        });

        throw { form };
      }
    }
  }

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title={t('s.menu.operacao.relatoriolmc')}
      relatorio="rellmc"
      serialize={(param) => handleSerializeForm(param)}
      validate={(param) => handleValidate(param)}
      initials={{
        ano: end.format('YYYY'),
        mes: (moment().month() + 1).toString(),
      }}
    >
      <Autocomplete
        name="unidadecomboio"
        label="codigonomeposto"
        url="postoscomboios"
        params={{
          wherefield: ['tipoposto'],
          valuewherefield: ['P'],
          typewherefield: ['EQUALS'],
        }}
        unique="idposto"
        title={t('s.menu.configuracao.posto')}
        defaultValue=""
        hiddens={[{ name: 'idposto' }, { name: 'nomeposto' }]}
        getValue={(value) => {
          setValuePosto(value);
        }}
      />

      <Select name="ano" label={t('s.geral.ano')} options={anos} />

      <Select name="mes" label={t('s.geral.mes')} options={meses} />

      <RadioGroup
        name="formato"
        label={t('s.relatorio.geral.formato')}
        options={[
          { label: 'PDF', value: 'pdf' },
          // { label: 'Excel', value: 'excel' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default Rellmc;
